<template>
  <div class="recommendDetail">
    <tab-nearby :type="3"></tab-nearby>
  </div>
</template>

<script>

import TabNearby from '@/components/position/tabNearby'

export default {
  name: "recommendDetail",
  props: {
  	
  },
  data(){
  	return {
  	}
  },
  components: {
  	TabNearby
  },
  methods: {
  	
  },
  created() {}
};
</script>

<style lang="scss" scoped>

</style>